<template>
  <div id="envoltorio">
    <div id="titulo" :style="estiloTexto">
      <slot></slot>
    </div>
    <div id="barra" :style="estilo" v-bind="$attrs">
      <span id="porcentaje" >{{porcentajeProgreso}}%</span>

      <div id="fondo" :style="estiloFondo">
        <div id="encaje">
          <div id="relleno" :style="estiloRelleno"></div>
        </div>
      </div>
    </div>
    <div v-if="subtitulo != undefined" id="subtitulo" :style="estiloTexto">
      {{subtitulo}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
      ancho: {
        type: Number,
        default: 50,
      },
      alto: {
        type: Number,
        default: 150,
      },
      colorRelleno: {
        type: String,
        default: 'khaki',
      },
      minimo: {
        type: Number,
        default: 0,
      },
      maximo: {
        type: Number,
        default: 100,
      },
      progreso: {
        type: Number,
        default: 50,
      },
      titulo: {
        type: [String, Number]
      },
      subtitulo: {
        type: [String, Number]
      }
  },
  computed: {
    estilo() {
      return {
        width: this.ancho+'px',
        height: this.alto+'px',
      }
    },
    estiloFondo() {
      return {
        borderColor: this.colorTextoAAplicar('#666666')
      }
    },
    estiloRelleno() {
      return {
        backgroundColor: this.colorRellenoAAplicar(),
        height: this.porcentajeProgreso+'%'
      }
    },
    estiloTexto() {
      return {
        color: this.colorTextoAAplicar('#444444')
      }
    },
    porcentajeProgreso() {
      if (this.progreso < this.minimo || this.maximo <= this.minimo)
        return 0;
      else if (this.progreso > this.maximo)
        return 100;
      else
        return Math.round ((this.progreso - this.minimo) * 100 / (this.maximo - this.minimo));
    }
  },
  methods:{
    colorRellenoAAplicar() {
      let color = this.colorRelleno;
      if (this.colorRelleno == 'auto') {
        if (this.porcentajeProgreso < 14)
          color = '#ff0000';
        else if (this.porcentajeProgreso < 28)
          color = '#ff9900';
        else if (this.porcentajeProgreso < 100)
          color = '#00ff00';
        else
          color = '#0066ff';
      }
      return color;
    },
    colorTextoAAplicar(color) {
      if (this.colorRelleno == 'auto' && this.porcentajeProgreso < 14)
        color = this.colorRellenoAAplicar();
      return color;
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped>
#envoltorio {
  display: inline-block;
  text-align: center;
}
#barra {
  display: inline-block;
}
#fondo {
  position: relative;
  padding: 1px;
  background-color: white;
  border-radius: 5px;
  border: 1px solid;
  width: 100%;
  height: 100%;
}
#encaje {
  position: relative;
  width: 100%;
  height: 100%
}
#relleno {
  position: absolute;
  border-radius: 4px;
  width: 100%;
  transition: height 500ms ease-in-out;
  bottom: 0px;
}
#porcentaje {
  float: left;
  position: relative;
  font-weight: 500;
  font-size: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
#titulo {
  margin-bottom: 7px;
  font-weight: 700;
  font-size: 12px;
  color: #444;
}
#subtitulo {
  font-weight: 500;
  font-size: 12px;
  color: #444;
}
</style>